import React, { useRef, useState } from 'react'
// import { setRecoil } from 'recoil-nexus'
// import { addLiquiditySlippage, swapSlippage, withdrawLiquiditySlippage } from '../../atoms'
import { SettingsIcon } from '../../svgIcons/SettingIcon'
import { useOnClickOutside } from '../../hooks/useClickOutside'
import { CloseIcon } from '../../svgIcons/CloseIcon'
import { HelptipIcon } from '../../svgIcons/HelptipIcon'
import PrimaryButton from '../PrimaryButton'

export const DEFAULT_SLIPPAGE = '2.0'

const slippageOptions = [
    { text: '0.5', value: 0.5 },
    { text: '1.0', value: 1 },
    { text: '2.0', value: 2 },
    { text: 'custom', value: -1 }
]

const texts = {
    slippageTooltip: `Your transaction will revert if the price Changes unfavorably by more than this percentage`
}

function BoxHeaderNew(props: {
    children?: JSX.Element
    className: string
    innerClass?: string
    name: string
    isRemoveSettings?: boolean
    slippage: string
    setOutsideSlippage?: (args?: any) => void
}) {
    const { className, isRemoveSettings = false, setOutsideSlippage, slippage } = props

    const [newSlippage, setSlippage] = useState(slippage)
    const [inputError, setInputError] = useState(false)
    const [isToolBoxOpen, setIsToolboxOpen] = useState(false)

    const ref = useRef(null)
    useOnClickOutside(ref, () => onClose())

    function onClose(isReset = true) {
        setIsToolboxOpen(false)
        if (isReset) setSlippage(slippage)
    }

    function onOKClick() {
        if (setOutsideSlippage) setOutsideSlippage(newSlippage)
        onClose(false)
    }

    const handleSlippageChange = (value: string) => {
        const regex = /^(([0-9]+[.]?[0-9]*)|([.][0-9]+))$/

        if (value === '') {
            // if (setOutsideSlippage) setOutsideSlippage('0')
            setSlippage('0')
            return
        }
        if (regex.test(value) && value.length <= 6 && Number(value) >= 0 && Number(value) <= 50) {
            setSlippage(value)
            // console.log('setOutsideSlippage ', setOutsideSlippage)

            // if (setOutsideSlippage) setOutsideSlippage(value)
            setInputError(false)
        } else {
            setInputError(true)
        }
    }

    // useEffect(() => {
    //     if (props.name === 'Swap') setRecoil(swapSlippage, slippage)
    //     if (props.name === 'Add Liquidity') setRecoil(addLiquiditySlippage, slippage)
    //     if (props.name === 'Remove Liquidity') setRecoil(withdrawLiquiditySlippage, slippage)
    // }, [slippage])

    function renderCustomSlippage() {
        let value = newSlippage === '0.5' || newSlippage === '1.0' || newSlippage === '2.0' ? '' : newSlippage
        return (
            <div key='custom-slip' className='rounded-xl bg-transparent overflow-hidden relative bg-transparent'>
                <input
                    placeholder='Custom'
                    onChange={(e) => {
                        if (e.target.value[e.target.value.length - 1] !== ',') handleSlippageChange(e.target.value)
                    }}
                    value={value}
                    className=' p-2 rounded-xl bg-transparent w-full h-full outline-none'
                    style={{ border: '1px solid white', maxWidth: '100px' }}
                />
                <div className='absolute right-[16px] top-[50%] pointer-events-none justify-end w-full flex items-center' style={{ transform: 'translate(0, -50%)' }}>
                    <span>%</span>
                </div>
            </div>
        )
    }

    function renderSlippageBox(slip: { text: string; value: number }, index: number) {
        if (slip.value === -1) return renderCustomSlippage()

        const isSelected = Number(newSlippage) === slip.value
        return (
            <div
                key={index}
                className={`w-[69px] flex justify-center items-center p-2 mr-2 rounded-xl cursor-pointer`}
                style={{ border: isSelected ? '1px solid #0AE8F9' : '1px solid #0C3F6D' }}
                onClick={() => handleSlippageChange(slip.text)}>
                {slip.text}%
            </div>
        )
    }

    function renderError() {
        if (!inputError) return null
        return (
            <div className='flex text-[#961515] font-bold items-center mt-4'>
                <HelptipIcon className='w-3 h-3 mr-2' />
                <span className='text-[16px]'>Max value = 50%</span>
            </div>
        )
    }

    function renderToolBox() {
        if (!isToolBoxOpen) return null

        const slippages = slippageOptions.map(renderSlippageBox)

        return (
            <div
                style={{ boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.47), -17px -5px 16px rgba(0, 0, 0, 0.25)', background: '#151D44' }}
                className='flex p-6 rounded-xl flex-col border-[1px] border-[#0C3F6D] absolute top-[28px] right-0 w-[320px] lg:w-[380px] z-[100]'>
                <div className='mb-6 w-full flex justify-between'>
                    <span className='text-white font-bold text-[24px]'>Transaction Setting</span>
                    <CloseIcon onClick={() => onClose()} className='w-g h-6 cursor-pointer' />
                </div>
                <div className='flex-col'>
                    <div className='relative flex items-center mb-5'>
                        <span className='block text-[18px] font-bold'>Max Slippage</span>
                        <div className='ml-2 group flex'>
                            <HelptipIcon className='w-5 h-5' />
                            <span className='w-[280px] left-0 group-hover:visible invisible group-hover:opacity-100 transition-opacity bg-[#242C58] text-sm text-gray-100 rounded-md absolute opacity-0 top-[30px] p-3 z-[1]'>
                                {texts.slippageTooltip}
                            </span>
                        </div>
                    </div>
                    <div className='flex text-xs lg:text-[16px]'>{slippages}</div>
                    {renderError()}
                </div>
                <div className='bg-[#0C3F6D] w-full h-[1px] mt-4' />
                <div className='w-full flex justify-end mt-6'>
                    <PrimaryButton onClick={onOKClick} className=' w-[56px] text-[18px]' size='sm'>
                        <span>Ok</span>
                    </PrimaryButton>
                </div>
            </div>
        )
    }

    return (
        <div className={`relative ${className}`}>
            <div className='border-b-[1px] border-[#0C3F6D] pb-1 lg:pb-[16px]'>
                <div ref={ref} className='relative flex justify-between items-center'>
                    {props.name ? <span className='text-[22px] font-bold'>{props.name}</span> : null}
                    {props.children ? props.children : null}
                    {isRemoveSettings ? null : <SettingsIcon className='cursor-pointer' onClick={() => setIsToolboxOpen(!isToolBoxOpen)} />}
                    {renderToolBox()}
                </div>
            </div>
        </div>
    )
}

export default BoxHeaderNew
